import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "../../../theme/customTheme";

export const useAnnouncementsBannerStyles = makeStyles({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: designTokens.spacing[2],
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[6],
    paddingRight: designTokens.spacing[6],
    pointerEvents: "none",
  },
  banner: {
    pointerEvents: "auto",
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[3],
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[4],
    paddingRight: designTokens.spacing[4],
    borderRadius: designTokens.borderRadius.md,
    width: "100%",
    maxWidth: "800px",
  },
  bannerWarning: {
    backgroundColor: designTokens.semantic.warningLight,
    border: `1px solid ${designTokens.semantic.warning}`,
  },
  bannerInformational: {
    backgroundColor: designTokens.semantic.successLight,
    border: `1px solid ${designTokens.semantic.success}`,
  },
  iconWarning: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: designTokens.semantic.warning,
  },
  iconInfo: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: designTokens.semantic.success,
  },
  contentWarning: {
    flex: 1,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    lineHeight: "20px",
    color: designTokens.semantic.warningDark,
    minWidth: 0,
    "& p": {
      margin: 0,
      padding: 0,
      display: "inline",
    },
    "& a": {
      color: "inherit",
      fontWeight: designTokens.fontWeight.semibold,
      textDecorationLine: "underline",
      ":hover": {
        textDecorationLine: "none",
      },
    },
  },
  contentInfo: {
    flex: 1,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    lineHeight: "20px",
    color: designTokens.semantic.successDark,
    minWidth: 0,
    "& p": {
      margin: 0,
      padding: 0,
      display: "inline",
    },
    "& a": {
      color: "inherit",
      fontWeight: designTokens.fontWeight.semibold,
      textDecorationLine: "underline",
      ":hover": {
        textDecorationLine: "none",
      },
    },
  },
  dismissWarning: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    cursor: "pointer",
    width: "24px",
    height: "24px",
    padding: "4px",
    border: "none",
    backgroundColor: "transparent",
    color: designTokens.semantic.warningDark,
    borderRadius: designTokens.borderRadius.sm,
    transition: `all ${designTokens.transition.fast}`,
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
    ":hover": {
      backgroundColor: "rgba(146, 64, 14, 0.1)",
    },
    ":focus-visible": {
      outlineWidth: "2px",
      outlineStyle: "solid",
      outlineColor: designTokens.semantic.warningDark,
      outlineOffset: "2px",
    },
  },
  dismissInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    cursor: "pointer",
    width: "24px",
    height: "24px",
    padding: "4px",
    border: "none",
    backgroundColor: "transparent",
    color: designTokens.semantic.successDark,
    borderRadius: designTokens.borderRadius.sm,
    transition: `all ${designTokens.transition.fast}`,
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
    ":hover": {
      backgroundColor: "rgba(6, 95, 70, 0.1)",
    },
    ":focus-visible": {
      outlineWidth: "2px",
      outlineStyle: "solid",
      outlineColor: designTokens.semantic.successDark,
      outlineOffset: "2px",
    },
  },
});
